import { useEffect } from "react";
import { FeedbackButton } from "pushfeedback-react";
import { defineCustomElements } from "pushfeedback/loader";
import "pushfeedback/dist/pushfeedback/pushfeedback.css";

const projectId = process.env.REACT_APP_PUSHFEEDBACK_PROJECT_ID;

function PushFeedbackWidget() {
  useEffect(() => {
    if (projectId) {
      defineCustomElements(window);
    }
  }, []);

  if (!projectId) {
    return null;
  }

  return (
    <FeedbackButton
      project={projectId}
      button-position="bottom-right"
      modal-position="bottom-right"
      button-style="dark"
    >
      Feedback
    </FeedbackButton>
  );
}

export default PushFeedbackWidget;
